(function () {
  if (window.ThreeCitiesDesignBreadcrumb && window.ThreeCitiesDesignBreadcrumb.bound) return;

  var STORAGE_KEY = '3cd_breadcrumb_trail';

  function saveTrail(url, label) {
    if (!url || !label) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ url: url, label: label }));
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function clearTrail() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function getTrail() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function isHomePath() {
    var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '/') return true;
    return /^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(path);
  }

  function isProductHref(href) {
    if (!href || href.charAt(0) === '#') return false;
    try {
      return new URL(href, window.location.origin).pathname.indexOf('/products/') !== -1;
    } catch (e) {
      return String(href).indexOf('/products/') !== -1;
    }
  }

  function isAllowedTrail(trail) {
    if (!trail || !trail.url || !trail.label) return false;
    var url = String(trail.url).toLowerCase();
    if (url.indexOf('/collections/') !== -1) return false;
    if (url.indexOf('/products/') !== -1) return false;
    return true;
  }

  function saveFromListingPage() {
    var el = document.querySelector('[data-breadcrumb-save]');
    if (el) {
      saveTrail(el.dataset.breadcrumbUrl, el.dataset.breadcrumbLabel);
      return;
    }
    if (isHomePath()) clearTrail();
  }

  function saveFromClickTarget(target) {
    var panel = target && target.closest
      ? target.closest('[data-breadcrumb-url][data-breadcrumb-label]')
      : null;
    if (panel) {
      var panelUrl = panel.getAttribute('data-breadcrumb-url');
      var panelLabel = panel.getAttribute('data-breadcrumb-label');
      if (panelUrl && panelLabel) {
        saveTrail(panelUrl, panelLabel);
        return;
      }
    }
    saveFromListingPage();
  }

  function initApplyContext() {
    var parentLink = document.querySelector('[data-breadcrumb-parent]');
    if (!parentLink) return;

    var trail = getTrail();
    if (!isAllowedTrail(trail)) return;

    parentLink.href = trail.url;
    parentLink.textContent = trail.label;
  }

  function onDocumentClick(e) {
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    if (!isProductHref(link.getAttribute('href') || link.href)) return;
    saveFromClickTarget(e.target);
  }

  window.ThreeCitiesDesignBreadcrumb = {
    bound: true,
    save: saveTrail,
    clear: clearTrail,
    saveFromClickTarget: saveFromClickTarget
  };

  document.addEventListener('click', onDocumentClick, true);

  function init() {
    saveFromListingPage();
    initApplyContext();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });
})();
